import { render } from "./formularioPersonales.vue?vue&type=template&id=29d36d35"
import script from "./formularioPersonales.vue?vue&type=script&lang=js"
export * from "./formularioPersonales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__